import React from "react";
import { Box, Typography } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import GradientButton from "../../../input/GradientButton";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

/**
 * Shown when the user has exactly one task.
 * Offers to create more tasks or start the existing one immediately.
 */
const SingleTaskStep = ({ task, onCreateMore, onStartTask }) => {
  return (
    <Box className="task-guide-step task-guide-step--single-task">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          You've got one task waiting for you!
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-step__task-highlight">
        {task.emoji && (
          <span className="task-guide-step__task-emoji">
            <Emoji unified={task.emoji} size={24} />
          </span>
        )}
        <Typography variant="h3" sx={{ margin: 0 }}>
          {task.name}
        </Typography>
      </Box>

      <Box className="task-guide-step__single-actions">
        <Box
          className="task-guide-step__create-another-button"
          onClick={onCreateMore}
        >
          <Typography variant="body2" sx={{ margin: 0, fontWeight: 500 }}>
            + Create more tasks
          </Typography>
        </Box>
        <GradientButton text="Start task" onClick={onStartTask} />
      </Box>
    </Box>
  );
};

export default SingleTaskStep;
